export enum toastTypeColor {
    red = 'danger',
    green = 'success',
    blue = 'primary'
}
export enum toastTime {
    small = 2000,
    medium = 3000,
    long = 4000,
}